// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pbFBWrlA2CGLVMEzsd4l{width:100%;height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column}.pbFBWrlA2CGLVMEzsd4l .t59mImYspjE6brZPQtyG{max-width:1024px;width:100%;height:100%;display:flex;flex-direction:column;justify-content:center}.pbFBWrlA2CGLVMEzsd4l .t59mImYspjE6brZPQtyG .fwnrUFMSZu4sOjsCWYfN{flex:2 1;display:flex;flex-direction:column;justify-content:center;align-items:flex-start}.pbFBWrlA2CGLVMEzsd4l .t59mImYspjE6brZPQtyG .fwnrUFMSZu4sOjsCWYfN h4{margin-bottom:0em}.pbFBWrlA2CGLVMEzsd4l .t59mImYspjE6brZPQtyG .fwnrUFMSZu4sOjsCWYfN .dTNAIkfm2HKWtPnvV7m5{display:flex;flex-direction:row;justify-content:center;align-items:center}.pbFBWrlA2CGLVMEzsd4l .t59mImYspjE6brZPQtyG .fwnrUFMSZu4sOjsCWYfN .dTNAIkfm2HKWtPnvV7m5 .zkh7EQMY401TWTfIy7sV{flex:1 1}.pbFBWrlA2CGLVMEzsd4l .t59mImYspjE6brZPQtyG .fwnrUFMSZu4sOjsCWYfN .dTNAIkfm2HKWtPnvV7m5 .zkh7EQMY401TWTfIy7sV:first-of-type{flex:0 0 50px}.pbFBWrlA2CGLVMEzsd4l .t59mImYspjE6brZPQtyG .gtk2Eu6xG8eN2QHqmOFQ{flex:1 0 50px;display:flex;justify-content:center;align-items:center;margin-top:20px;width:100%}.pbFBWrlA2CGLVMEzsd4l .t59mImYspjE6brZPQtyG .gtk2Eu6xG8eN2QHqmOFQ>div{width:70%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"PreProduction": `pbFBWrlA2CGLVMEzsd4l`,
	"rightComponent": `t59mImYspjE6brZPQtyG`,
	"listWrapper": `fwnrUFMSZu4sOjsCWYfN`,
	"row": `dTNAIkfm2HKWtPnvV7m5`,
	"column": `zkh7EQMY401TWTfIy7sV`,
	"infoBoxWrapper": `gtk2Eu6xG8eN2QHqmOFQ`
};
export default ___CSS_LOADER_EXPORT___;
